<!-- 座席 -->
<template>
  <div v-for="(seat, index) in seats" :key="index" class="row">
    <div class="th cell"><span v-if="index == 0">払いもどす</span></div>
    <div class="th-2"><span v-if="index == 0">座席</span></div>
    <div class="cell">
      {{ seat.car_number }}号車 {{ seat.display_number }}
      <span v-if="seat.price_division == 'adult'">(おとな)</span>
      <span v-else-if="seat.price_division == 'child'">(こども)</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "MFITTRefundSeats",
  props: {
    seats: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.row {
  display: table-row;
}
.cell {
  font-weight: bold;
  display: table-cell;
  padding: 8px;
}
.th {
  font-weight: 100;
  padding-right: 30px;
  color: grey;
}
.th-2 {
  font-weight: 100;
  color: grey;
  margin-left: 14px;
  margin-right: 15vw;
}
</style>
